/**
 * 
 * key
 * 
 */


const key = 'cmVjZWl2ZWRfZG9j'

export default key 